import { Component, Input, OnInit } from "@angular/core";
import { ThemeService } from "app/core/theme/theme.service";
import { WhiteLabelService } from "app/core/white-label/white-label.service";
import {
  LogoFileType,
  LogoLocation,
} from "app/core/white-label/white-label.type";
import { NgIf } from "@angular/common";

@Component({
  selector: "logo",
  templateUrl: "./logo.component.html",
  styleUrls: ["./logo.component.scss"],
  imports: [NgIf],
})
export class LogoComponent implements OnInit {
  @Input() public location: string | undefined;
  @Input() public hasLink: boolean = true;
  @Input() public e2e: string;

  public logoSrc: string = "";
  public showLogo: boolean = true;

  constructor(
    private themeService: ThemeService,
    private whiteLabelService: WhiteLabelService,
  ) {}

  public ngOnInit(): void {
    const customLogoData: LogoLocation | undefined =
      this.whiteLabelService.getCustomLogo(this.location);
    if (customLogoData?.hide) {
      this.showLogo = false;
    } else {
      const logoFilename: string | undefined = customLogoData
        ? customLogoData.name
        : "logo";
      const logoFileType: LogoFileType | undefined = customLogoData?.fileType
        ? customLogoData!.fileType
        : "svg";
      this.logoSrc = `${this.themeService.assetPath}/logo/${logoFilename}.${logoFileType}`;
    }
  }
}
